import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { SearchFilterParams } from "~pages/Conducts/ConductListPage/types/searchFilterParams.ts";
import type { Conduct } from "~types/conduct.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";

export const useDeleteConduct = (params: SearchFilterParams) => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (conductId: string) => {
      return await request(`${sport}/o/${organizationId}/conduct/${conductId}`, { method: "DELETE" });
    },
    onSuccess: (response: DefaultOperationSuccessResponse, conductId: string) => {
      if (isDefaultOperationSucceeded(response)) {
        queryClient.setQueryData<{ data: Array<Conduct> } | undefined>(["conducts", sport, organizationId, params], (oldValues) => {
          return {
            ...oldValues,
            data: oldValues?.data?.filter((item: Conduct) => item?.conductId !== conductId) || [],
          };
        });
      }
    },
  });
};
